module.exports = __webpack_public_path__ + "static/img/logo.b029c43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.jpg
// module id = iywV
// module chunks = 8